import {
  Bell01Icon,
  MessageCircle01Icon,
  Users01Icon,
  ThumbsUpIcon,
  AtSignIcon,
} from '@systemeio/icons'
import { EventTypeEnum } from 'modules/profile/notifications/enums/notification-settings-enum'

export const notificationIcons = {
  [EventTypeEnum.COMMENT_ON_COMMUNITY_POST]: MessageCircle01Icon,
  [EventTypeEnum.COMMENT_REPLY_ON_COMMENT]: MessageCircle01Icon,
  [EventTypeEnum.COMMENT_ON_COURSE_CREATED_BY_ME]: MessageCircle01Icon,
  [EventTypeEnum.MENTION_IN_COMMUNITY_POST]: AtSignIcon,
  [EventTypeEnum.MENTION_IN_COMMENT_ON_COMMUNITY_POST]: AtSignIcon,
  [EventTypeEnum.COMMENT_IS_LIKED]: ThumbsUpIcon,
  [EventTypeEnum.COMMUNITY_NEW_PENDING_POST]: Users01Icon,
  [EventTypeEnum.COMMUNITY_POST_IS_PUBLISHED]: Users01Icon,
  [EventTypeEnum.COMMUNITY_POST_IS_LIKED]: ThumbsUpIcon,
  [EventTypeEnum.REPORTED_CONTENT_ALERT]: Bell01Icon,
} as const satisfies Record<EventTypeEnum, React.ElementType>
